import states from '../variables/states';
import http from '../utils/http';
import UserChangePassword from '../view-model/users/UserChangePassword';
import UserAddress from '../view-model/users/UserAddress';
import UserChange from '../view-model/users/UserChange';
import UserChangeAddress from '../view-model/users/UserChangeAddress';
import UserTaxData from '../view-model/users/UserTaxData';
import UserChangeTaxData from '../view-model/users/UserChangeTaxData';
import UserPolicies from '../view-model/users/UserPolicies';
import UserPlanUsage from '../view-model/users/UserPlanUsage';

const setUserGeneralData = ({ user, ...generalData }: UserChange) =>
    http.put<null>(`/v2.1/users/${user}/general`, generalData, 'questions' in generalData ? { credentials: 'include' } : {});

const setUserPassword = ({ user,  ...password }: UserChangePassword) =>
    http.put<null>(`/v2.1/users/${user}/credentials`, password);

const getUserAddress = (user: number) =>
    http.get<UserAddress | null>(`/v2.1/users/${user}/addresses`);

const setUserAddress = ({ user,  ...address }: UserChangeAddress) =>
    http.post<null>(`/v2.1/users/${user}/addresses`, address);

const getUserTaxData = (user: number) =>
    http.get<UserTaxData | null>(`/v2.1/users/${user}/taxdata`);

const setUserTaxData = ({ user, ...taxData }: UserChangeTaxData) =>
    http.post<null>(`/v2.1/users/${user}/taxdata`, taxData);

const acceptPolicies = (user: number) =>
    http.post<null>(`/v2.1/users/${user}/policies`, { privacyAccepted: true, termsAccepted: true });

const getUserPolicies = (user: number) =>
    http.get<UserPolicies>(`/v2.1/users/${user}/policies`);

const getUserUsage = (user: number) =>
    http.get<UserPlanUsage>(`/v2.1/users/${user}/usage`);

const getZipCode = async (zipcode: string): Promise<Partial<UserAddress> | null> => {
    zipcode = zipcode.split('').filter(char => !Number.isNaN(Number(char))).join('');

    let { result } = await http.get<{
        cep: string,
        logradouro: string,
        bairro: string,
        localidade: string,
        uf: string
    } | {
        erro: true
    }>(`https://viacep.com.br/ws/${zipcode}/json/`, { auth: false });

    if ('erro' in result)
        return null;

    const address = {
        address: result.logradouro,
        district: result.bairro,
        city: result.localidade,
        state: states.find(state => state.code === (result as any).uf)?.name
    };

    return (Object.keys(address) as (keyof typeof address)[]).reduce((data: any, key) => {
        if (address[key])
            data[key] = address[key];

        return data;
    }, {});
}

const usersService = { acceptPolicies, setUserGeneralData, setUserPassword, getUserAddress, setUserAddress, getUserTaxData, setUserTaxData, getUserPolicies, getUserUsage, getZipCode };

export default usersService;
